import type { AdminCrewReportBulkRequestCheckboxProps } from "../../models/admin-crew-report.models";
import AdminCrewReportCheckbox from "./AdminCrewReportCheckbox";
import type { KeyboardEvent, MouseEvent } from "react";

const AdminCrewReportBulkRequestCheckbox = ({
  checked,
  disabled,
  vessel,
  onChange,
}: AdminCrewReportBulkRequestCheckboxProps) => {
  const stopGridEvent = (event: MouseEvent<HTMLInputElement> | KeyboardEvent<HTMLInputElement>) => {
    event.stopPropagation();
  };

  return (
    <span className="grid h-full w-full place-items-center">
      <AdminCrewReportCheckbox
        checked={checked}
        disabled={disabled}
        ariaLabel={`Select ${vessel.vesselName || vessel.imoNumber} for bulk Crew Report request`}
        dataTest={`admin-crew-report-bulk-request-checkbox-${vessel.imoNumber}`}
        onChange={(event) => onChange(vessel.imoNumber, event.target.checked)}
        onClick={stopGridEvent}
        onKeyDown={stopGridEvent}
      />
    </span>
  );
};

export default AdminCrewReportBulkRequestCheckbox;
